import { createFileRoute, redirect } from "@tanstack/react-router";
import { canAccessAdmin } from "@/lib/admin";
import { authClient } from "@/lib/auth-client";
import { AdminUserPage } from "./-AdminUserPage";

export const Route = createFileRoute("/_settings/admin_/$userId")({
  beforeLoad: async () => {
    const { data } = await authClient.getSession();
    if (!canAccessAdmin(data?.user.role)) throw redirect({ to: "/" });
  },
  component: AdminUserRoute,
  staticData: { title: "User" },
});

function AdminUserRoute() {
  const { userId } = Route.useParams();
  return <AdminUserPage userId={userId} />;
}
